import React from 'react';
import ColorScreens from './ColorScreens';
import { SecurityMobile, SecurityNew } from '../../assets/index';
import useIsMobile from '../../hooks/useIsMobile';
import SocLogo from '../../assets/utilities/21972-312_SOC_NonCPA.png';
import { SecurityScanOutlined, FileProtectOutlined } from '@ant-design/icons';

const SecuritySection = () => {
  const isMobile = useIsMobile();

  const content = {
    title: 'With Great Power Comes Great Security',
    imageSrc: isMobile ? SecurityMobile : SecurityNew,
    backgroundColor: '#FAE8FF',
    titleColor: '#60007B',
  };

  return (
    <div id={'security'} style={{ backgroundColor: '#ffffff', paddingBottom: '60px' }}>
      <ColorScreens {...content}>
        <p className="colorpage-text body-text-1">
          A highly compatible system with <strong>24/7 availability</strong>, global disaster
          recovery, <strong>automated hourly backups</strong>, data maintenance, MFA, and 256-bit
          encryption for both transit and <strong>storage</strong>, ensuring seamless business
          continuity.
        </p>
      </ColorScreens>
      
      <div style={{
        margin: isMobile ? '-20px 20px 20px' : '-50px auto 20px',
        maxWidth: '1000px',
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: isMobile ? '30px 20px' : '40px 60px',
        boxShadow: '0 20px 40px rgba(96, 0, 123, 0.08)',
        border: '1px solid rgba(96, 0, 123, 0.05)',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isMobile ? 'stretch' : 'center',
        position: 'relative',
        zIndex: 10,
        gap: '30px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div style={{ backgroundColor: '#F9F5FA', padding: '15px', borderRadius: '16px' }}>
            <img src={SocLogo} alt="SOC 2 Certification" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
          </div>
          <div style={{ textAlign: 'left' }}>
            <h4 style={{ margin: 0, color: '#60007B', fontSize: '20px', fontWeight: 'bold' }}>SOC 2 Type II</h4>
            <p style={{ margin: '5px 0 0', color: '#666', fontSize: '14px' }}>Certified Security</p>
          </div>
        </div>

        {!isMobile && <div style={{ width: '1px', height: '60px', backgroundColor: '#EAD5EE' }} />}

        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <a href="/privacy-policy" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '20px', cursor: 'pointer' }}>
          <div style={{ backgroundColor: '#F9F5FA', padding: '15px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '60px', height: '60px', boxSizing: 'content-box' }}>
            <FileProtectOutlined style={{ fontSize: '40px', color: '#60007B' }} />
          </div>
          <div style={{ textAlign: 'left' }}>
            <h4 style={{ margin: 0, color: '#60007B', fontSize: '20px', fontWeight: 'bold' }}>Privacy Policy</h4>
            <p style={{ margin: '5px 0 0', color: '#666', fontSize: '14px' }}>Read our commitment</p>
          </div>
        </a>
        </div>

        {!isMobile && <div style={{ width: '1px', height: '60px', backgroundColor: '#EAD5EE' }} />}

        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div style={{ backgroundColor: '#F9F5FA', padding: '15px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '60px', height: '60px', boxSizing: 'content-box' }}>
            <SecurityScanOutlined style={{ fontSize: '40px', color: '#60007B' }} />
          </div>
          <div style={{ textAlign: 'left' }}>
            <h4 style={{ margin: 0, color: '#60007B', fontSize: '20px', fontWeight: 'bold' }}>VAPT Tested</h4>
            <p style={{ margin: '5px 0 0', color: '#666', fontSize: '14px' }}>Independent Penetration Testing</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySection;
